let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("7qc7K")]).then(() => parcelRequire('lG2jM'));